import {createQuery} from 'react-query-kit'

import {apiGetRecaps} from '../api/scribe/api-get-recaps'
import type {Recap} from '../api/scribe/types'

export const useRecapsQuery = createQuery<Recap | null>({
  queryKey: ['memex', 'recaps'],
  fetcher: async () => {
    return await apiGetRecaps()
  },
})
